module.exports = __webpack_public_path__ + "static/media/5_4.39ef3a75.jpg";